import { Injectable } from "@angular/core";

import { AngularFireList, AngularFireObject } from "@angular/fire/database";
import { BehaviorSubject, combineLatest } from "rxjs";
import { map } from "rxjs/operators";
import {
  AgentAngularFireDatabase,
  FarmerAngularFireDatabase,
} from "../../views/usage/firebase";
import {
  DailyUsersData,
  AgrishopTags,
  SessionDataInfo,
  FormattedDailyUsersData,
  FormattedSessionDataInfo,
} from "../../views/usage/interface";

@Injectable({
  providedIn: "root",
})
export class AppUsageService {
  usageListRef: AngularFireList<any>;
  usageRef: AngularFireObject<any>;
  _agentfilteredRecords$: BehaviorSubject<
    FormattedSessionDataInfo<AgrishopTags>[]
  > = new BehaviorSubject([]);
  _farmerfilteredRecords$: BehaviorSubject<
    FormattedSessionDataInfo<AgrishopTags>[]
  > = new BehaviorSubject([]);
  isLoading$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  currentTag: BehaviorSubject<string> = new BehaviorSubject("agrishop");
  constructor(
    private agentdb: AgentAngularFireDatabase,
    private farmerdb: FarmerAngularFireDatabase
  ) {
    this.isLoading$.next(true);
    this.currentTag$.subscribe((value) => {
      this.agentdb
        .list(`usage_sessions/${value}`)
        .valueChanges()
        .subscribe((recordsPerDay: DailyUsersData[]) => {
          const formattedData = this.formatData(recordsPerDay);
          const sortedData = this.sortData(formattedData);
          this._farmerfilteredRecords$.next(sortedData);
          this.isLoading$.next(false);
        });
      this.farmerdb
        .list(`usage_sessions/${value}`)
        .valueChanges()
        .subscribe((recordsPerDay: DailyUsersData[]) => {
          const formattedData = this.formatData(recordsPerDay);
          const sortedData = this.sortData(formattedData);
          this._farmerfilteredRecords$.next(sortedData);
          this.isLoading$.next(false);
        });
    });
  }

  private sortData(formattedData: FormattedSessionDataInfo<AgrishopTags>[]) {
    return formattedData.sort((a, b) => {
      try {
        let lastSessionA = a.sessions[0].sort(
          (x, y) => x.timestamp - y.timestamp
        );
        let lastSessionB = b.sessions[0].sort(
          (x, y) => x.timestamp - y.timestamp
        );
        return lastSessionB[0].timestamp - lastSessionA[0].timestamp;
      } catch (error) {
        return 0;
      }
    });
  }

  public get currentTag$() {
    return this.currentTag.asObservable();
  }

  public setCurrentTag(value: string) {
    return this.currentTag.next(value);
  }

  formatData(recordsPerDay: DailyUsersData[]) {
    let sessionDataInfo: SessionDataInfo<AgrishopTags>[] = [];
    recordsPerDay.forEach((day) => {
      const values = Object.values(day);
      values.forEach((val) => {
        sessionDataInfo.push(val);
      });
    });
    let map: FormattedDailyUsersData = {};
    sessionDataInfo.map(({ info, sessions }) => {
      if (info) {
        map[info.userId] = { info, sessions: [] };
      }
    });
    for (let { info, sessions } of sessionDataInfo) {
      if (info) {
        const sessionsData = map[info.userId].sessions || [];
        Object.values(sessions || {}).forEach((session) => {
          sessionsData.push(session);
        });
      }
    }
    return Object.values(map);
  }

  public get filteredRecords$() {
    return combineLatest([
      this._agentfilteredRecords$.asObservable(),
      this._farmerfilteredRecords$.asObservable(),
    ]).pipe(
      map(([first, second]) => {
        return [...first, ...second];
      })
    );
  }
}
